// TO DO Check if there are CONSTANTS to exclude

export default {
  REDUX_NAMESPACE: 'IULI/APPLICATION',

  RESET_STORE: 'APPLICATION/RESET_STORE',

  SAVE_ADMIN_BODY_REF: 'APPLICATION/SAVE_ADMIN_BODY_REF',

  TOGGLE_LOADING: 'APPLICATION/TOGGLE_LOADING',
  HIDE_LOADING: 'APPLICATION/HIDE_LOADING',
  RESET_APPLICATION_LOADING: 'APPLICATION/RESET_APPLICATION_LOADING',

  TOGGLE_DIALOG: 'APPLICATION/TOGGLE_DIALOG',
  HIDE_DIALOG: 'APPLICATION/HIDE_DIALOG',

  TOGGLE_ERROR_DIALOG: 'APPLICATION/TOGGLE_ERROR_DIALOG',
  HIDE_ERROR_DIALOG: 'APPLICATION/HIDE_ERROR_DIALOG',

  TOGGLE_DIALOG_V2: 'APPLICATION/TOGGLE_DIALOG_V2',
  HIDE_DIALOG_V2: 'APPLICATION/HIDE_DIALOG_V2',

  DIALOG_CONFIRM_YES: 'APPLICATION/DIALOG_CONFIRM_YES',
  DIALOG_CONFIRM_NO: 'APPLICATION/DIALOG_CONFIRM_NO',

  REGISTER_RESOURCE: 'APPLICATION/REGISTER_RESOURCE',
  UNREGISTER_RESOURCE: 'APPLICATION/UNREGISTER_RESOURCE',
};
